import React, { FC, Fragment } from 'react';

import { Props } from '../props';

import * as Styled from './styled';

/**
 * Regular field, label <-> value pair
 *
 * @param props             Props
 * @param props.field       The field to render
 * @param props.field.label Concierge field label
 * @param props.field.value Concierge field value
 * @returns                 The component itself
 */
const FieldNormal: FC<Props> = ({ field: { label, value } }) => {
  return (
    <>
      <Styled.Dt>{label}</Styled.Dt>
      {/* Support for multiline text separated by \n */}
      {value?.split('\n').map((line, index) => (
        // No way to calculate key otherwise here
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      ))}
    </>
  );
};

export default FieldNormal;
